/**
 * author: Ananthapadmanabhan V K
 */
import React, { useEffect, useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./SupplierRiskScore.scss";
import { withTranslation } from "react-i18next";
import { Button, Table, Form, Collapse, OverlayTrigger } from "react-bootstrap";
import Pagination from "../../../components/Pagination/Pagination";
import { BiSearch, BiChevronDown, BiSort } from "react-icons/bi";
import { CgSortAz } from "react-icons/cg";
import { FcFinePrint } from "react-icons/fc";

import DatapointSuppliersService from "../../../core/service/DatapointSuppliersService";
import {
  DEFAULT_ITEMS_PER_PAGE,
  LIST_DEF_SORT,
  RiskReportFrequency,
  SORT_ORDER_DESC,
  startYear,
  currentYear,
} from "../../../core/constants/common";
import CompanyService from "../../../core/service/CompanyService";
import Utils from "../../../core/utilities/Utils";
import RiskConfigService from "../../../core/service/RiskConfigService";
import TabFilter from "../../../components/TabFilter/TabFilter";
import CompanyRiskScoreInput from "../CompanyRiskScoreInput/CompanyRiskScoreInput";
import nodataimg from "../../../images/nodatafound.png";
import { RegulationContext } from "../../../App";
const SupplierRiskScore = ({ t }) => {
  const [itemsTotalCount, setItemTotalCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(DEFAULT_ITEMS_PER_PAGE);
  const [currentPage, setCurrentPage] = useState(1);
  const [key, setKey] = useState("");
  const [order, setOrder] = useState(SORT_ORDER_DESC);
  const [sortField, setSortField] = useState(LIST_DEF_SORT);
  const riskFrequencyList = RiskReportFrequency({ t });
  const [frequency, setFrequency] = useState("");
  const [encoded, setEncoded] = useState(null);
  const [frequencyparam, setFrequencyParam] = useState(null);
  const [supplierlist, setSupplierList] = useState([]);
  const navigate = useNavigate();
  const [shown, setShown] = useState({});
  const [regulations, setRegulations] = useState([]);
  const [selRegulation, setSelRegulation] = useState(null);
  const [regulation, setRegulation] = useState([]);
  var data = JSON.parse(localStorage.getItem("authority"));
  const companyid = data?.profile?.company?.id;
  const [annualyear, setAnnualYear] = useState(new Date().getFullYear());
  const [frequencymonth, setFrequencyMonth] = useState("");
  const [configType, setConfigType] = useState("Supplier");
  const { glbRegulation, setGlbRegulation } = useContext(RegulationContext);
  const filterData = [
    { name: t("Supplier.label"), value: t("Supplier.label") },
    { name: t("Company.label"), value: t("Company.label") },
  ];
  useEffect(() => {
    if (glbRegulation.id) {
      getSubscriptions();
    }
  }, [configType, glbRegulation.id]);
  const getSubscriptions = async (e) => {
    setShown({});
    if (companyid) {
      let subType = "R";
      CompanyService.getCompanySubscriptions(companyid, subType)
        .then((response) => {
          let resRegulations = response?.data?.regulations;

          var filter = [];
          filter = resRegulations.filter(x => x.id == glbRegulation.id);
          setRegulations([...filter]);
          // if(window.location.pathname=='/admin/standard') {
          //   filter = resRegulations;
          // } else {
          //   filter = resRegulations.filter(x=> x.id==glbRegulation.id); 
          // }
          // filter = response.data;
          // console.log('window.location.pathname',window.location.pathname)
          // setList([...filter]);
          var string = Utils.generateUrlParamCompanyRegulation(
            companyid,
            glbRegulation.id
          );
          setSelRegulation(glbRegulation.id);
          var encodedDat = Utils.encodeBase64(string);
          setEncoded(encodedDat);
          getRegulationDetails(glbRegulation.id);
          // setFrequency("ANNUAL");
          // handleExpand()
        })
        .catch((error) => {
          //ErrorHandlingService.handleError(error.response.status);
          console.log("err", error);
        });
    }
  };
  const handleSearch = (e) => {
    var searchKey = e.target.value;
    setKey(searchKey);
    getSupplierList(
      encoded,
      frequency,
      0,
      itemsPerPage,
      searchKey,
      sortField,
      annualyear,
      frequencymonth
    );
  };
  const handleSort = (val) => {
    if (sortField === val && order === "asc") {
      setOrder("desc");
    } else {
      setOrder("asc");
    }
    setSortField(val);
    getSupplierList(
      encoded,
      frequency,
      0,
      itemsPerPage,
      key,
      val,
      annualyear,
      frequencymonth
    );
  };
  const getSupplierList = (
    encoded,
    period,
    pageNumber,
    itemsPerPageVal,
    key,
    sortField,
    year,
    month
  ) => {
    if (pageNumber > 0) {
      pageNumber = pageNumber - 1;
    } else {
      setCurrentPage(1);
    }
    var perPage = null;
    if (itemsPerPageVal > 0) {
      perPage = itemsPerPageVal;
    } else {
      perPage = itemsPerPage;
    }
    let frequencyParam = year + "-" + month + "-01";
    var sort = sortField + "," + order;
    setFrequencyParam(frequencyParam);
    DatapointSuppliersService.getSuppliers(
      encoded,
      frequencyParam,
      pageNumber,
      perPage,
      key,
      sort,
      configType
    )
      .then((response) => {
        var totalPages = parseFloat(response.headers["x-total-count"]);
        setItemTotalCount(totalPages);
        setSupplierList([...response.data]);
      })
      .catch((error) => {
        //ErrorHandlingService.handleError(error.response.status);
        console.log("err", error);
      });
  };
  const frequencyOnChange = (value) => {
    setFrequency(value);
    getSupplierList(
      encoded,
      value,
      0,
      itemsPerPage,
      key,
      sortField,
      annualyear,
      frequencymonth
    );
  };

  const viewRisk = (val) => {
    val.regulation = selRegulation;
    var encodedDat = Utils.encodeBase64(JSON.stringify(val));
    navigate("/company_admin/risk_input/" + encodedDat);
  };

  const riskColor = (val) => {
    if (val) {
      for (let i = 0; i < regulation?.resultConfigs?.length; i++) {
        let iterate = regulation.resultConfigs[i];
        if (val >= iterate.minScore && val <= iterate.maxScore) {
          return { color: iterate.colorCode };
        }
        if (i === regulation.resultConfigs.length - 1) {
          return { color: "inherit" };
        }
      }
    }
  };
  const handleExpand = (id) => {
    setSelRegulation(id);
    getRegulationDetails(id);
  };
  const getRegulationDetails = async (id) => {
    RiskConfigService.getRegulationDetails(id, configType)
      .then((response) => {
        setRegulation(response.data);
        setFrequency(response.data.frequency);
        let month = "01";
        switch (response.data.frequency) {
          case "ANNUAL":
          case "QUARTERLY":
          case "HALF_YEARLY":
            month = "01";
            setFrequencyMonth("01");
            break;
          case "FINANCIAL_YEAR":
            month = "04";
            setFrequencyMonth("04");
            break;
          default:
            break;
        }
        var string = Utils.generateUrlParamCompanyRegulation(companyid, id);
        var encodedDat = Utils.encodeBase64(string);
        setEncoded(encodedDat);
        configType === "Supplier" && getSupplierList(
          encodedDat,
          frequency,
          0,
          itemsPerPage,
          key,
          sortField,
          annualyear,
          month
        );
        // const newVal = !shown[id];
        // var obj = function (shown) {
        //   Object.keys(shown).forEach(function (key) {
        //     shown[key] = false;
        //   });
        //   return shown;
        // };
        // setShown({
        //   ...obj,
        //   [id]: newVal,
        // });
      })
      .catch((error) => {
        console.log("err", error);
      });
  };
  const renderSwitch = () => {
    const options = [];
    for (let i = currentYear; i >= startYear; i--) {
      options.push(
        <option value={i} key={i}>
          {i}
        </option>
      );
    }
    switch (frequency) {
      case "ANNUAL":
        return (
          <div>
            {" "}
            <select
              className="form-select"
              required
              onChange={(e) => {
                setAnnualYear(e.target.value);
                getSupplierList(
                  encoded,
                  frequency,
                  0,
                  itemsPerPage,
                  key,
                  sortField,
                  e.target.value,
                  frequencymonth
                );
                // getMainTableList(0, itemsPerPage, frequency, e.target.value, frequencymonth);
              }}
              value={annualyear}
            >
              {/* <option value="">{t("Select.label")}</option> */}
              {options}
            </select>
          </div>
        );
      case "FINANCIAL_YEAR":
        options.length = 0;
        for (let i = currentYear; i >= startYear; i--) {
          options.push(
            <option value={i} key={i}>
              {i}(APRIL)
            </option>
          );
        }
        return (
          <div className="row m-0">
            <select
              className="form-select col-md-6"
              required
              onChange={(e) => {
                setAnnualYear(e.target.value);
                setFrequencyMonth("04");
                getSupplierList(
                  encoded,
                  frequency,
                  0,
                  itemsPerPage,
                  key,
                  sortField,
                  e.target.value,
                  "04"
                );
              }}
              value={annualyear}
            >
              {/* <option value="">{t("Select.label")}</option> */}

              {options}
            </select>

            {/* <select
            className="form-select col-md-6"
            required
            onChange={(e) => {
              setFrequencyMonth(e.target.value);
              getSupplierList(encoded, frequency, 0, itemsPerPage, key, sortField, annualyear,  e.target.value);
            }}
            value={frequencymonth}>
            <option value="01">JAN-DEC</option>
            <option value="04">APR-MAR</option>
          </select> */}
          </div>
        );
      case "QUARTERLY":
        return (
          <div className="row m-0">
            <div className="col-md-6 pe-1 ps-0">
              <select
                className="form-select"
                required
                onChange={(e) => {
                  setAnnualYear(e.target.value);
                }}
                value={annualyear}
              >
                {options}
              </select>
            </div>
            <div className="col-md-6 pe-1 ps-1">
              <select
                className="form-select"
                required
                onChange={(e) => {
                  setFrequencyMonth(e.target.value);
                  getSupplierList(
                    encoded,
                    frequency,
                    0,
                    itemsPerPage,
                    key,
                    sortField,
                    annualyear,
                    e.target.value
                  );
                }}
                value={frequencymonth}
              >
                {/* <option value="">{t("Select.label")}</option> */}
                <option value="01">Q1</option>
                <option value="04">Q2</option>
                <option value="07">Q3</option>
                <option value="10">Q4</option>
              </select>
            </div>



          </div>
        );
      case "HALF_YEARLY":
        return (
          <div className="row m-0">
            <div className="col-md-6 pe-1 ps-0">
              <select
                className="form-select "
                required
                onChange={(e) => {
                  setAnnualYear(e.target.value);
                }}
                value={annualyear}
              >
                {options}
              </select>
            </div>

            <div className="col-md-6 pe-1 ps-1">
              <select
                className="form-select "
                required
                onChange={(e) => {
                  setFrequencyMonth(e.target.value);
                  getSupplierList(
                    encoded,
                    frequency,
                    0,
                    itemsPerPage,
                    key,
                    sortField,
                    annualyear,
                    e.target.value
                  );
                }}
                value={frequencymonth}
              >
                <option value="01">JAN-JUN</option>
                <option value="07">JUL-DEC</option>
              </select>
            </div>
          </div>
        );
      default:
        return "";
    }
  };
  const callbackTab = (val) => {
    setConfigType(val);
  };
  return (
    <div className="SupplierRiskOverview">
      <div className="List_header pb-2">
        <h5 className="MH m-0">{t("Overview.label")}</h5>
        <div className="choose_comapny_supplier_box">
          <TabFilter data={filterData} callbackValue={callbackTab} />
        </div>
      </div>

      {regulations?.map((item, index) => (
        <div>
          <div className="Topics_headeView">
            <ul>
              <li>
                Risk : <b>{item.name}</b>
              </li>
            </ul>
          </div>
          <div className="ROV_Add_Card " key={item.id}>
            <div>
              {/* <Collapse in={shown[item.id]}> */}
              <div className="col-lg-12 p-0" id={item.id}>
                {(() => {
                  switch (configType) {
                    case "Supplier":
                      return supplierlist && supplierlist !== undefined ? (
                        <>
                          <div className="RiskOverview_list_header">
                            <div className="RiskOverview_list_sorts_menu">
                              <ul>
                                <li>
                                  <div className="List_table-card_Search_Box">
                                    <Form>
                                      <input
                                        type="text"
                                        className="form-control"
                                        onChange={handleSearch}
                                        placeholder={t("Search.label")}
                                      />
                                      <Link
                                        to="#"
                                        className="Search_iocnBox"
                                      >
                                        <BiSearch />
                                      </Link>
                                    </Form>
                                  </div>
                                </li>
                                <li>{renderSwitch()}</li>
                              </ul>
                              <ul>
                                <li className="filter">
                                  <a href="#">
                                    <button className="btn btn-secondary"><CgSortAz /> {t("Filter.label")}</button>
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="RiskOverview_list_body">
                            <div className="overflow-auto sticy_table">
                              <Table
                                hover
                                className="text-center"
                              >
                                <thead>
                                  {supplierlist[0] && (
                                    <tr>
                                      <th className="text-start">
                                        {t("SupplierName.label")}
                                      </th>
                                      <th>{t("OverAllScore.label")}</th>
                                      {supplierlist[0].dataPoints?.map(
                                        (item, index) => (
                                          <th
                                            onClick={() =>
                                              handleSort(item.riskParam)
                                            }
                                            key={index}
                                          >
                                            {item.riskParam} <BiSort />
                                          </th>
                                        )
                                      )}
                                    </tr>
                                  )}
                                </thead>

                                <tbody>
                                  {supplierlist?.map((item, index) => (
                                    <tr key={index}>
                                      <td className="text-start">
                                        <a
                                          href="#"
                                          onClick={() => viewRisk(item)}
                                        >
                                          <OverlayTrigger
                                            placement="top"
                                            overlay={Utils.renderTooltip(
                                              t(
                                                "Viewdetailsofriskparameters.label"
                                              )
                                            )}
                                          >
                                            <span>
                                              {" "}
                                              {item.supplier.legalName}
                                            </span>
                                          </OverlayTrigger>
                                        </a>
                                      </td>
                                      <td>
                                        <span
                                          style={riskColor(
                                            item.weightedScore
                                          )}
                                        >
                                          {item.weightedScore}
                                        </span>
                                      </td>
                                      {item.dataPoints.map(
                                        (item2, index) => (
                                          <td key={index}>
                                            {item2.score}
                                          </td>
                                        )
                                      )}
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>
                            </div>
                            <div className="p-2 RiskOverview_list_footer">
                              <div className="ROV_list_footer_RiskColor me-auto">
                                <ul>
                                  {regulation &&
                                    regulation?.resultConfigs &&
                                    regulation?.resultConfigs?.map(
                                      (item, i) => (
                                        <li key={i}>
                                          <span
                                            style={{
                                              backgroundColor:
                                                item.colorCode,
                                            }}
                                          ></span>
                                          {/* {t("LowRisk.label")} */}
                                          {item.resultType}
                                        </li>
                                      )
                                    )}
                                </ul>
                              </div>
                              <div className=" ROV_list_footer_count">
                                <Pagination
                                  itemsTotalCount={itemsTotalCount}
                                  itemsPerPage={itemsPerPage}
                                  currentPage={currentPage}
                                  setCurrentPage={setCurrentPage}
                                  alwaysShown={true}
                                  setItemsPerPage={setItemsPerPage}
                                  pageClicked={(pageNum, perPage) => {
                                    getSupplierList(
                                      encoded,
                                      frequencyparam,
                                      pageNum,
                                      perPage,
                                      key,
                                      sortField,
                                      annualyear,
                                      frequencymonth
                                    );
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        <div className="Nodatafound_box">
                          <h6><FcFinePrint className="me-2" /> {t("Nodatafound.label")}</h6>
                        </div>
                      );
                    case "Company":
                      return (
                        selRegulation && (
                          <CompanyRiskScoreInput
                            regId={selRegulation}
                            configType={configType}
                          />
                        )
                      );
                    default:
                      return null;
                  }
                })()}
              </div>
            </div>
          </div>

        </div>
      ))
      }
    </div >
  );
};

export default withTranslation()(SupplierRiskScore);
